import { ref } from "vue";

const toast = ref({ visible: false, message: "", type: "info" });
let toastTimer = null;

const typeStyles = {
  success: { icon: "fas fa-check-circle", bg: "hsl(var(--success))", color: "hsl(var(--success-foreground))" },
  error: { icon: "fas fa-times-circle", bg: "hsl(var(--destructive))", color: "hsl(var(--destructive-foreground))" },
  info: { icon: "fas fa-info-circle", bg: "hsl(var(--info))", color: "hsl(var(--info-foreground))" },
  warning: { icon: "fas fa-exclamation-triangle", bg: "hsl(var(--warning))", color: "hsl(var(--warning-foreground))" },
};

const show = (message, type = "info") => {
  toast.value.message = message;
  toast.value.type = type;
  toast.value.visible = true;
  clearTimeout(toastTimer);
  toastTimer = setTimeout(() => {
    toast.value.visible = false;
  }, 5000);
};

export function useToast() {
  return {
    toast,
    success: (message) => show(message, "success"),
    error: (message) => show(message, "error"),
    info: (message) => show(message, "info"),
    warning: (message) => show(message, "warning"),
    styles: typeStyles,
  };
}
